
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.795.781a2.749 2.749 0 013.839 0l13.571 13.333a2.634 2.634 0 010 3.772L12.634 31.219a2.749 2.749 0 01-3.839 0 2.634 2.634 0 010-3.771L20.447 16 8.795 4.552a2.634 2.634 0 010-3.771z","fill":"currentColor"}})])
          )
        }
      }
    